<script setup lang="ts">
import { ref } from "vue";
import { ExcelImportResponse } from "../../../../types/Views/MappingWizard/ExcelImportResponse";
import Modal from "../../../Reusables/Modal/Modal.vue";

const props = defineProps<{
  uploadResponse: ExcelImportResponse;
}>();
const emits = defineEmits(["toggleModal"]);

const uploadResponse = ref<ExcelImportResponse>(props.uploadResponse);
</script>

<template>
  <Modal
    size="xl"
    heading="Imported File Errors"
    @toggle-modal="() => emits('toggleModal')">
    <div class="mr-2 flex h-full flex-col overflow-y-auto pr-2">
      <div class="border-element-stroke bg-surface text-type-muted grid grid-cols-8 rounded-t-xl border p-2 text-sm">
        <span class="px-2">Row</span>
        <span class="col-span-7 px-2">Reason</span>
      </div>
      <div
        v-for="(rowError, i) in uploadResponse.importRowErrors"
        :key="i"
        class="border-element-stroke text-text-color odd:bg-surface grid grid-cols-8 border border-t-0 px-2 text-xs last:rounded-b-xl">
        <span class="border-element-stroke border-r p-2">{{ rowError.rowNumber }}</span>
        <span class="col-span-7 p-2">{{ rowError.reason }}</span>
      </div>
    </div>
  </Modal>
</template>
